/**
 * L6 — Full Screen Visual + Bottom Headline Strip
 * Full-screen image/video with a solid branded strip at bottom for headline.
 * Classic TV news lower-third style.
 */
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { SceneProps } from '../../types';
import {
  SceneContainer, Visual, HeadlineText, SubheadlineText,
  GlobalOverlays,
} from './shared';

export const L6_VisualPlusBottomHeadline: React.FC<SceneProps> = (props) => {
  const { headline, subheadline, assets, colorPalette, headlineFont, subheadlineFont } = props;
  const primary = assets.primary ?? assets.video;

  const stripHeight = 160;

  return (
    <SceneContainer bg={colorPalette.background}>
      {/* Full-screen visual — slightly cropped at bottom for strip */}
      <AbsoluteFill style={{ bottom: stripHeight, top: 0, height: `calc(100% - ${stripHeight}px)` }}>
        <Visual asset={primary} kenBurns kenBurnsDirection="in" layerKey="primaryMedia" />
      </AbsoluteFill>

      {/* Headline strip */}
      <AbsoluteFill style={{
        top: 'auto', height: stripHeight,
        background: colorPalette.primary,
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
        padding: '0 80px',
        borderTop: `4px solid ${colorPalette.accent}`,
      }}>
        <HeadlineText
          text={headline}
          font={{
            ...headlineFont,
            fontSize: Math.min(headlineFont.fontSize * 0.85, 42),
            color: '#fff',
          }}
          delay={6}
          maxLines={2}
          layerKey="headline"
        />
        {subheadline && (
          <SubheadlineText
            text={subheadline}
            font={{ ...subheadlineFont, color: colorPalette.accent, fontSize: 20 }}
            delay={16}
            style={{ marginTop: 6 }}
            layerKey="subheadline"
          />
        )}
      </AbsoluteFill>

      <GlobalOverlays props={props} />
    </SceneContainer>
  );
};
